import React, {useEffect, useState} from 'react';
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonLabel,
    IonInput,
    IonSelect,
    IonSelectOption,
    IonButton,
    useIonAlert,
    IonTextarea,
    IonRow,
    IonCol,
    IonFooter,
    IonItem,
    IonSearchbar,
    IonList,
    IonIcon,
    IonButtons,
} from '@ionic/react';
import {
    actionToEditUpdateJobPortalDataById, actionToGetAdminJobPostingByFilter, actionToGetJobPostingByFilter,
    actionToGetUserJobPostData,
    actionToGetUserSessionData,
    actionToUploadJobPortalDataWithImage,
} from "../apiHelpers/CommonAction";
import {_getDepartmentsList, _getIndianStates, _getWorkTypes} from "../apiHelpers/CommonHelper";
import useStore from "../zustand/useStore";
import moment from "moment-timezone";
import {arrowBack, star} from "ionicons/icons";


export default function AddJobFormModal({ isOpen,dataForEditing,selectedUserType,fromAdminList, onClose,setIsLoading,fromJobList = false }) {
    const [form, setForm] = useState({
        title: '',
        company: '',
        category: '',
        description: '',
        department: '',
        responsiblities: '',
        requirement: '',
        location: '',
        experience: '',
        salary_min: '',
        salary_max: '',
        apply_email: '',
        work_type: '',
        valid_date: '',
        jobImage: '',
        city: '',
        jobPdf: '',
    });

    const [presentAlert] = useIonAlert();
    const [errors, setErrors] = useState({});
    const {resetFilters,jobPostingState} = useStore();
    const [showPopover, setShowPopover] = useState(false);
    const [searchText, setSearchText] = useState("");

    const filteredStates = _getIndianStates.filter(state =>
        state.toLowerCase().includes(searchText.toLowerCase())
    );

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };


    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setForm(prev => ({
                ...prev,
                jobImage: file
            }));
        }
    };

    const handlePdfUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setForm(prev => ({
                ...prev,
                jobPdf: file
            }));
        }
    };

    const validate = () => {
        const newErrors = {};
        if (!form.title) newErrors.title = 'Job title is required';
        if (!form.company) newErrors.company = 'Company name is required';
        if (!form.category) newErrors.category = 'Category is required';
        if (!form.description) newErrors.description = 'Description is required';
        if (!form.department) newErrors.department = 'Department is required';
        if (!form.location) newErrors.location = 'Location is required';
        if (!form.experience) newErrors.experience = 'Experience is required';
        // if (!form.salary_min) newErrors.salary = 'Salary is required';
        // if (!form.salary_max) newErrors.salary = 'Salary is required';
        if (!form.city) newErrors.city = 'Job City is required';

        // if (form.salary_min && form.salary_min > 2000000) {
        //     newErrors.salary = "Minimum salary cannot exceed 20,00,000";
        // }
        //
        // if (form.salary_max && form.salary_max < 50000) {
        //     newErrors.salary = "Maximum salary must be at least 50,000";
        // }
        //
        // // Relation validation
        // if (
        //     form.salary_min &&
        //     form.salary_max &&
        //     Number(form.salary_min) > Number(form.salary_max)
        // ) {
        //     newErrors.salary = "Minimum salary cannot be greater than maximum salary";
        // }
        if (!form.apply_email) newErrors.apply_email = 'Apply email is required';
        if (!form.work_type) newErrors.work_type = 'Work type is required';
        return newErrors;
    };

    const handleSubmit = () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setIsLoading(true);

        const formData = new FormData();

        formData.append('title', form.title);
        formData.append('company', form.company);
        formData.append('location', form.location);
        formData.append('category', form.category);
        formData.append('description', form.description);
        formData.append('department', form.department);
        formData.append('responsiblities', form.responsiblities);
        formData.append('requirement', form.requirement);
        formData.append('experience', form.experience);
        formData.append('salary_min', form.salary_min);
        formData.append('city', form.city);
        formData.append('salary_max', form.salary_max);
        formData.append('apply_email', form.apply_email);
        formData.append('work_type', form.work_type);
        if(dataForEditing?.id){
            formData.append('id', dataForEditing?.id);
            formData.append('existing_image_url', dataForEditing.image_url);
            formData.append('existing_pdf_url', dataForEditing.pdf_url);
        }
        formData.append('valid_date', moment(form.valid_date).format('YYYY-MM-DD'));

        if (form.jobPdf) {
            formData.append('jobPdf', form.jobPdf);
        }

        if (form.jobImage) {
            formData.append('jobImage', form.jobImage);
        }

        if(dataForEditing?.id){
            actionToEditUpdateJobPortalDataById(formData)
                .then(() => {
                    setIsLoading(false);
                    if(fromAdminList){
                        actionToGetAdminJobPostingByFilter(false, {offset: jobPostingState?.offset, user_type:selectedUserType});
                    }else{
                        actionToGetJobPostingByFilter(true,{me_mode:true,user_type:1});
                        actionToGetUserJobPostData();
                    }
                    resetFilters();
                    onClose(); // ✅ Close modal only after success
                })
                .catch(() => {
                    setIsLoading(false);
                    presentAlert({
                        message: 'Something went wrong while uploading.',
                        buttons: ['OK'],
                    });
                });
        }else{
            actionToUploadJobPortalDataWithImage(formData)
                .then(() => {
                    setIsLoading(false);
                    if(fromJobList){
                        actionToGetJobPostingByFilter(true,{offset: 0,me_mode:true,user_type:1});
                        actionToGetUserJobPostData();
                    }else if(fromAdminList){
                        actionToGetAdminJobPostingByFilter(true, { offset: 0 ,user_type:1});
                    }else{
                        actionToGetUserSessionData();
                    }
                    resetFilters();
                    onClose(); // ✅ Close modal only after success
                })
                .catch(() => {
                    setIsLoading(false);
                    presentAlert({
                        message: 'Something went wrong while uploading.',
                        buttons: ['OK'],
                    });
                });
        }
    };

    useEffect(() => {
        if (isOpen) {
            if (dataForEditing?.id) {
                setForm({
                    id: dataForEditing?.id,
                    title: dataForEditing?.title || '',
                    company: dataForEditing?.company || '',
                    category: dataForEditing?.category || '',
                    description: dataForEditing?.description || '',
                    department: dataForEditing?.department || '',
                    responsiblities: dataForEditing?.responsiblities || '',
                    requirement: dataForEditing?.requirement || '',
                    location: dataForEditing?.location || '',
                    experience: dataForEditing?.experience || '',
                    salary_min: dataForEditing?.salary_min || '',
                    salary_max: dataForEditing?.salary_max || '',
                    apply_email: dataForEditing?.apply_email || '',
                    work_type: dataForEditing?.work_type || '',
                    valid_date: moment(dataForEditing?.valid_date).format('YYYY-MM-DD') || '',
                    city: dataForEditing?.city || ''
                });
            } else {
                setForm({
                    title: '',
                    company: '',
                    category: '',
                    description: '',
                    department: '',
                    responsiblities: '',
                    requirement: '',
                    location: '',
                    experience: '',
                    salary_min: '',
                    salary_max: '',
                    apply_email: '',
                    work_type: '',
                    valid_date: '',
                    jobImage: '',
                    jobPdf: '',
                    city: '',
                });
            }
        }
    }, [isOpen, dataForEditing]);

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onClose}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onClose}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{dataForEditing?.id ? 'Modify' : 'Add'} Job Post</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding bottom-2 no_padding_top">
                <div>
                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Job Title<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput placeholder="Enter job title" className={"rfp_form_input"} value={form.title} onIonInput={e => handleChange('title', e.detail.value)} />
                    </div>
                    {errors.title && <p className="error-text">{errors.title}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Company Name<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput placeholder="Enter company name" className={"rfp_form_input"} value={form.company} onIonInput={e => handleChange('company', e.detail.value)} />
                    </div>
                    {errors.company && <p className="error-text">{errors.company}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Candidate Category<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonSelect
                            className={"rfp_form_input"}
                            placeholder="Select category"
                            value={form.category}
                            onIonChange={(e) => handleChange('category', e.detail.value)}
                        >
                            <IonSelectOption value="CA">CA</IonSelectOption>
                            <IonSelectOption value="CA Articleship">CA Articleship</IonSelectOption>
                            <IonSelectOption value="CA Finalist">CA Finalist</IonSelectOption>
                            <IonSelectOption value="Accountants">Accountants</IonSelectOption>
                            <IonSelectOption value="Other">Other ancillary Professional (CS / LLB / CMA)</IonSelectOption>
                        </IonSelect>
                    </div>
                    {errors.category && <p className="error-text">{errors.category}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Brief Job Description<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonTextarea placeholder="Enter job description" className={"rfp_form_input"} value={form.description} onIonInput={e => handleChange('description', e.detail.value)} />
                    </div>
                    {errors.description && <p className="error-text">{errors.description}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Salary Budget (P.A)</IonLabel>
                        <IonRow className={"rfp_submit_form_item_row_sub"}>
                            <IonCol>
                                <IonLabel>Min</IonLabel>
                                <IonInput type={"number"} placeholder="Salary min P.A" className={"rfp_form_input"} value={form.salary_min} onIonInput={e => handleChange('salary_min', e.detail.value)} />
                            </IonCol>
                            <IonCol>
                                <IonLabel>Max</IonLabel>
                                <IonInput type={"number"} placeholder="Salary max P.A" className={"rfp_form_input"} value={form.salary_max} onIonInput={e => handleChange('salary_max', e.detail.value)} />
                            </IonCol>
                        </IonRow>
                    </div>
                    {errors.salary && <p className="error-text">{errors.salary}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Job Responsibilities</IonLabel>
                        <IonTextarea placeholder="Enter job responsibilities" className={"rfp_form_input"} value={form.responsiblities} onIonInput={e => handleChange('responsiblities', e.detail.value)} />
                    </div>
                    {errors.responsiblities && <p className="error-text">{errors.responsiblities}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Job Requirement</IonLabel>
                        <IonTextarea placeholder="Enter job requirement" className={"rfp_form_input"} value={form.requirement} onIonInput={e => handleChange('requirement', e.detail.value)} />
                    </div>
                    {errors.requirement && <p className="error-text">{errors.requirement}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Job City<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonTextarea placeholder="Enter job city" className={"rfp_form_input"} value={form.city} onIonInput={e => handleChange('city', e.detail.value)} />
                    </div>
                    {errors.city && <p className="error-text">{errors.city}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Location<IonIcon icon={star} className="required-star" /></IonLabel>
                        <div onClick={() => setShowPopover(true)} className={"select_popup_injecttor_sele"}>
                            {form?.location ? <span className={"actual_selection"}>{form?.location}</span> :
                                <span className={"select_place_holder"}>Select State <svg
                                    xmlns="http://www.w3.org/2000/svg" fill="#5e5e5e" width="10px" height="10px" className="ionicon" viewBox="0 0 512 512"><path
                                    d="M64 144l192 224 192-224H64z"></path></svg></span>}
                        </div>

                        <IonModal
                            isOpen={showPopover}
                            onDidDismiss={() => setShowPopover(false)}
                            cssClass="custom-alert-modal"
                        >
                            <div className="custom-alert-box">
                                <h2 className="alert-title">Select State</h2>

                                <IonSearchbar
                                    value={searchText}
                                    onIonInput={(e) => setSearchText(e.detail.value)}
                                    placeholder="Search..."
                                />

                                <IonList className="alert-list">
                                    {filteredStates.map((state, idx) => (
                                        <IonItem
                                            key={idx}
                                            button
                                            onClick={() => {
                                                handleChange("location", state);
                                                setShowPopover(false);
                                            }}
                                        >
                                            {state}
                                        </IonItem>
                                    ))}
                                </IonList>
                            </div>
                        </IonModal>
                    </div>
                    {errors.location && <p className="error-text">{errors.location}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Department<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonSelect
                            className={"rfp_form_input"}
                            placeholder="Select Department"
                            value={form.department}
                            onIonChange={(e)=>handleChange('department', e.detail.value)}
                        >
                            {_getDepartmentsList.map((state, index) => (
                                <IonSelectOption key={index} value={state}>
                                    {state}
                                </IonSelectOption>
                            ))}
                        </IonSelect>
                    </div>
                    {errors.department && <p className="error-text">{errors.department}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Experience in years<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput type={"number"} placeholder="Enter experience in years" className={"rfp_form_input"} value={form.experience} onIonInput={e => handleChange('experience', e.detail.value)} />
                    </div>
                    {errors.experience && <p className="error-text">{errors.experience}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Apply Email<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput placeholder="Enter apply email" className={"rfp_form_input"} value={form.apply_email} onIonInput={e => handleChange('apply_email', e.detail.value)} />
                    </div>
                    {errors.apply_email && <p className="error-text">{errors.apply_email}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Opening Valid Till</IonLabel>
                        <IonInput placeholder="Enter valid till date" type={"date"} className={"rfp_form_input"} value={form.valid_date} onIonInput={e => handleChange('valid_date', e.detail.value)} />
                    </div>
                    {errors.valid_date && <p className="error-text">{errors.valid_date}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Work Type<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonSelect
                            className={"rfp_form_input"}
                            placeholder="Select Work Type"
                            value={form.work_type}
                            onIonChange={(e)=>handleChange('work_type', e.detail.value)}
                        >
                            {_getWorkTypes.map((state, index) => (
                                <IonSelectOption key={index} value={state}>
                                    {state}
                                </IonSelectOption>
                            ))}
                        </IonSelect>
                    </div>
                    {errors.work_type && <p className="error-text">{errors.work_type}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Company Logo</IonLabel>
                        <IonItem className={"ion-no-padding ion-margin-bottom"}>
                            <input
                                className={"attach-pdf"}
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleImageUpload(e)}
                            />
                        </IonItem>
                    </div>
                    {errors.jobImage && <p className="error-text">{errors.jobImage}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel >Job Description (Pdf Only)</IonLabel>
                        <IonItem className={"ion-no-padding ion-margin-bottom"}>
                            <input
                                className={"attach-pdf"}
                                type="file"
                                accept="application/pdf"
                                onChange={(e) => handlePdfUpload(e)}
                            />
                        </IonItem>
                    </div>
                    {errors.jobImage && <p className="error-text">{errors.jobImage}</p>}
                </div>
            </IonContent>
            <IonFooter className="job_detail_sheet_footer ion-padding">
                <IonToolbar>
                    <IonRow>
                        <IonCol>
                            <IonButton className="close_job_detail_button" expand="block" onClick={onClose}>Close</IonButton>
                        </IonCol>
                        <IonCol>
                            <IonButton className="apply_job_button" onClick={handleSubmit} expand="block">Submit Job</IonButton>
                        </IonCol>
                    </IonRow>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
}
